module.exports = __webpack_public_path__ + "media/images/konintodoke/takes/img_konin-photo-48befe8747365b7f1e6af3d3c301aec6.jpg";